// extracted by mini-css-extract-plugin
export default {"container":"weatherForm_container__bWDTv","input":"weatherForm_input__aHS6A"};